import React, { Component } from 'react';
import { Card, Table, Alert, Grid } from 'tabler-react';
import { ListPageTitle } from 'components/ListPageTitle';
import { TableAction } from 'components/buttons/TableAction';
import { connect } from 'react-redux';
import { actionGetMobileEmergencies } from 'redux/actions/MobileEmergenciesActions';

class EmergencyList extends Component {

  componentDidMount = () => {
    this.get();
  }

  get = () => {
    this.props.get();
  }

  renderTable = () => {
    return (
      this.props.oEmergencies.aMobileEmergencies.map(oEmergency => {
        return (
          <Table.Row key={oEmergency.name}>
            <Table.Col>
              {oEmergency.name}
            </Table.Col>
            <Table.Col>
              {oEmergency.contactphone}
            </Table.Col>
            <Table.Col>
              {oEmergency.alternatecontactphone}
            </Table.Col>
            <Table.Col className="text-center">
              <TableAction iconName="eye" tooltip="Detalles" to='/' />
              <TableAction iconName="edit" tooltip="Editar" to='/' />
              <TableAction iconName="trash" tooltip="Eliminar" to='/' />
            </Table.Col>
          </Table.Row>
        )
      })
    )
  }

  render = () => {
    return (
      <Card>
        <ListPageTitle addButton={true}>
          Listado de Emergencias Móviles
        </ListPageTitle>
        {
          this.props.oEmergencies.aMobileEmergencies.length > 0 ?
            <div className="table-responsive">
              <Table className="card-table table-vcenter table-sm table-hover text-nowrap">
                <Table.Header>
                  <Table.Row>
                    <Table.ColHeader>
                      Nombre
                    </Table.ColHeader>
                    <Table.ColHeader>
                      Número de contacto
                    </Table.ColHeader>
                    <Table.ColHeader>
                      Número de contacto alternativo
                    </Table.ColHeader>
                    <Table.ColHeader>
                    </Table.ColHeader>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {
                    this.renderTable()
                  }
                </Table.Body>
              </Table>
            </div>
            :
            <Card.Body>
              <Grid.Row>
                <Grid.Col>
                  <Alert type="info" icon="info">
                    No hemos obtenido datos de emergencias móviles
                  </Alert>
                </Grid.Col>
              </Grid.Row>
            </Card.Body>
        }
        <Card.Footer />
      </Card>
    );
  }
}

const mapStateToProps = state => ({
  oEmergencies: state.mobileEmergenciesReducer,
})

const mapDispatchToProps = dispatch => ({
  get: () => {
    dispatch(actionGetMobileEmergencies());
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(EmergencyList);
